import React from 'react'


export const About = () => {
  return ( 
    <h2>Welcome to our simple notes application! Our application is designed to make note-taking easy and convenient. Whether you need to jot down a quick reminder, keep track of your to-do list, or write down your thoughts, our application has got you covered.

    With our application, you can create an account and start storing your notes right away. You can update your notes whenever you want and delete them if you no longer need them. Plus, you can log in anytime from anywhere to access your notes.
    
    We understand the importance of keeping your notes safe and secure. That's why we use the latest security measures to protect your data. You can trust that your notes will always be kept confidential.
    
    Our application is user-friendly and easy to navigate. You don't need to be tech-savvy to use it. Whether you're a student, professional, or anyone in between, our notes application is perfect for everyone.
    
    So what are you waiting for? Sign up today and start using our simple notes application to stay organized and on top of your game!</h2>
  )
}
